import { useCallback, useContext } from "react";

import { MaskedInput } from "~/components/TextInput";
import { setCorporalEvaluationImageIndex } from "~/modules/corporalEvaluation/services";
import { patchEvaluationAtom } from "~/modules/evalutation/services";
import { studentEvaluationDemoContext } from "~/pages/authenticated/personalTrainer/studentEvaluationDemo";

import { Mean } from "./Mean";

export const ChestInput: React.FC = () => {
	const { data } = useContext(studentEvaluationDemoContext);

	const handleUpdateField = useCallback(
		(index: number, value: number) => {
			const newArr = data ? data.chest : [];
			newArr[index] = +value;
			patchEvaluationAtom({ chest: newArr });
		},
		[data],
	);

	const handleFocus = useCallback(() => {
		setCorporalEvaluationImageIndex(1);
	}, []);

	return (
		<>
			<div className="whitespace-nowrap font-bold xl:font-normal">
				Peitoral (mm) &nbsp;
			</div>
			{data?.chest.map((val, index) => (
				<div key={`chest-${index}`}>
					<p className="block xl:hidden mb-2">Medida {index + 1}</p>
					<MaskedInput
						onFocus={handleFocus}
						value={val}
						placeholder="0"
						mask="float"
						inputMode="decimal"
						onChange={(v) => handleUpdateField(index, v)}
					/>
				</div>
			))}
			<div>
				<p className="block xl:hidden mb-2">Média</p>
				<Mean field="chest" />
			</div>
		</>
	);
};
